module.exports = __webpack_public_path__ + "static/media/title-big-home.fb54891a.png";